import {createAction, props} from '@ngrx/store'


export const savePolicy = createAction("savePolicy");
export const submitPolicy = createAction("submitPolicy");
export const customSavePolicy = createAction("customSavePolicy",props<{payload:any}>());